import React from 'react';
import { Modal } from 'react-bootstrap';
import { StarActiveIcon, ViewIcon } from 'assets/icons';
import { Button, Input, Pagination } from 'components';
import { Globals } from 'utils';
import ModalViewRating from './modal-view-rating';
import { ReportsService } from 'services';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

const MODAL = {
  NONE: 0,
  VIEW: 1,
};

const initialForm = {
  search_doctor: '',
  search_specialty: '',
};

class Ratings extends React.Component {

  state = {
    modal: MODAL.NONE,
    selectedItem: null,
    form: { ...initialForm },
    data: [],
    pagination: {
      pages: 1,
      page: 1,
    },
  }

  debounce?: NodeJS.Timeout;

  componentDidMount(): void {
    this.getRatings();
  }

  getRatings = async (page = 1) => {
    try {
      const res = await ReportsService.doctorRatings({ ...this.state.form, page });
      const { data, ...rest } = res as any;

      this.setState({
        data: data,
        pagination: rest,
      });

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  change = async (value: string | number | boolean, target: keyof typeof initialForm) => {
    const form = Globals.clone(this.state.form);
    form[target] = value;
    await this.setState({ form });

    if (this.debounce) clearTimeout(this.debounce);
    this.debounce = setTimeout(async () => this.getRatings(), 800);
  }

  cleanFilters = async () => {
    await this.setState((prev: any) => ({
      form: { ...initialForm, level_id: prev.form.level_id },
    }));

    this.getRatings();
  }

  setModal = (modal: number, item?: any) => {
    this.setState({ modal, selectedItem: item ?? null });
  }

  canCleanFilters = () => {
    const { search_doctor, search_specialty } = this.state.form;
    return !!search_doctor || !!search_specialty;
  }

  render() {

    const { form, modal } = this.state;
    const canCleanFilters = this.canCleanFilters();

    return (
      <div id="ratings">
        <Modal
          id="plans-view"
          show={modal === MODAL.VIEW}
          onHide={() => this.setModal(MODAL.NONE)}
        >
          <ModalViewRating
            user={this.state.selectedItem}
            onClose={() => this.setModal(MODAL.NONE)}
          />
        </Modal>

        <section className="filters">
          <div className="main-filter">
            <Input
              className="filter-x2"
              label="Médico"
              value={form.search_doctor}
              onChange={(e: IonChangeEvent) => this.change(e.target.value, 'search_doctor')}
            />
          </div>
          <div className="main-filter">
            <Input
              className="filter-x2"
              label="Especialidad"
              value={form.search_specialty}
              onChange={(e: IonChangeEvent) => this.change(e.target.value, 'search_specialty')}
            />
          </div>
          {canCleanFilters && (
            <Button clear onClick={this.cleanFilters}>
              Limpiar
            </Button>
          )}
        </section>

        <div className="rg-table">
          <table>
            <thead>
              <tr>
                <th>Médico</th>
                <th>Especialidad</th>
                <th>Calificación</th>
                <th>Encuestas</th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.map((user: any, index: number) => {
                return (
                  <tr key={index}>
                    <td>{ user?.full_name }</td>
                    <td>{ user?.specialty?.name }</td>
                    <td>
                      <div className="rating">
                        <span>{parseFloat(user?.rating).toFixed(1)}</span>
                        <div>
                          {[...Array(Math.floor(user.rating))].map((el) => (
                            <img src={StarActiveIcon} alt="rating" />
                          ))}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="actions">
                        <img
                          src={ViewIcon}
                          alt="Ver"
                          title="Ver"
                          onClick={() => this.setModal(MODAL.VIEW, user)}
                        />
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        <Pagination
          pages={this.state.pagination.pages}
          active={this.state.pagination.page}
          onChange={this.getRatings}
        />
      </div>
    )
  }
}

export default Ratings;